import { render, staticRenderFns } from "./CrashDirection.vue?vue&type=template&id=285d20b1&"
import script from "./CrashDirection.vue?vue&type=script&lang=ts&"
export * from "./CrashDirection.vue?vue&type=script&lang=ts&"
import style0 from "./CrashDirection.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports